import template from './mobile_configuration_help.html';
import * as Utils from '../../lib/savanna_utils.js';

class MobileConfigurationHelpViewModel
{
	constructor (dialog)
	{
		this.dialog = dialog;
	};

	close()
	{
		this.dialog.close();
	}
};

class MobileConfigurationHelpPage
{
	constructor (bindings)
	{
		this.viewModel = new MobileConfigurationHelpViewModel(this);
		this.bindings = bindings;
		const tr = Utils.get_translator('default');
	};

	init()
	{
		Utils.refresh_data_visible_roles();
	}
};

export default {
	name: 'MobileConfigurationHelp',
	dialog_class: MobileConfigurationHelpPage,
	template: template,
	template_filename: 'translation/dialogs/mobile_configuration_help',
	provider: 'ps'
};
